<template>
    <v-container>
        <!-- Navigation row -->
        <v-row justify="center">
            <v-btn-toggle rounded mandatory v-model="navigationIdx" @change="onNavigationChange">
                <v-btn>{{ $t('app.all') }}</v-btn>
                <v-btn>{{ $t('app.my') }}</v-btn>
            </v-btn-toggle>
        </v-row>

        <!-- Filter row -->
        <v-row v-if="!isContractor">
            <v-col v-if="!isAdmin">
                <v-select name="province" item-text="text" item-value="value"
                          :items="provinces" v-model="filteredProvince" @change="onProvinceSelectionChange"></v-select>
            </v-col>
            <v-col>
                <v-select name="pool" item-text="pool" item-value="pool"
                          :items="provinceUsers" v-model="filteredPool" @change="onPoolSelectionChange"></v-select>
            </v-col>
        </v-row>

        <!-- List of survey cards -->
        <v-row v-if="filteredSurveys && filteredSurveys.length > 0">
            <v-col cols="12" md="4" lg="4" v-for="survey in filteredSurveys" :key=survey.uuid>
                <survey-card :survey="survey" @showDialog="showDialog"></survey-card>
            </v-col>
        </v-row>

        <v-row v-else>
            <no-data></no-data>
        </v-row>

        <v-btn fab dark large bottom right fixed color="green" :to="{name: 'SurveyAdd'}">
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-dialog
            v-model="showAssignDialog"
            max-width="500"
        >
            <v-card>
                <v-card-title>
                    Benutzerzuweisung
                </v-card-title>
                <v-card-text>
                    <v-select
                        color="green"
                        :items="userListGrouped"
                        item-text="email"
                        item-value="id"
                        label="Userauswahl"
                        v-model="selectedUser"
                    ></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="green"
                        text
                        @click="showAssignDialog = false"
                    >
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="assignedUser!=null"
                            color="green"
                            text
                            @click="deleteUser" >
                            löschen
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green"
                        text
                        @click="assignUser"
                    >
                        zuweisen
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import SurveyCard from '../components/detail/survey/SurveyCard';
    import NoData from '../components/base/NoData';
    import {Provinces, Roles, Utils} from '../components/_helpers';

    export default {
        name: 'Surveys',
        components: {
            SurveyCard,
            NoData
        },
        computed: {
            isSuperAdmin() {
                let userProfile = this.$store.getters.userProfile
                return this.$store.getters.isAuthenticated && userProfile.role === Roles.ROLE_1.value
            },
            isAdmin() {
                let userProfile = this.$store.getters.userProfile
                return this.$store.getters.isAuthenticated && userProfile.role === Roles.ROLE_2.value
            },
            isContractor() {
                let userProfile = this.$store.getters.userProfile
                return this.$store.getters.isAuthenticated && userProfile.role === Roles.ROLE_3.value
            },
            filteredSurveys() {
                //sort surveys by date
                let sortedSurveys = this.$store.getters.filteredSurveyList
                sortedSurveys.sort((a,b)=> new Date(a.date) - new Date(b.date))
                // show only last survey for parent/child relation
                return sortedSurveys.filter(parent => sortedSurveys.findIndex(child => child.parentid == parent.uuid)<0)
            },
            userProfile() {
                return this.$store.state.user.userProfile
            },
            userListGrouped() {
                // Group user-list per province and return a Map<Province,[UserProfile]>
                let grouped = Utils.groupBy(this.$store.state.user.userList, 'province')
                //Filter on own province
                    let result = {}

                    // Return only those users which belong to the same province
                    let userList = grouped[this.userProfile.province]
                    // Return only those users which do not belong to an SUPERADMIN-role
                    if (userList) {
                        userList = userList.filter(user => {
                            return user.role !== Roles.ROLE_1.value
                        })
                    }

                    result = userList

                    console.log(result)

                    return result
            },
            provinces() {
                return Provinces.list()
            },
            provinceUsers() {
                if (!this.filteredProvince) {
                    console.warn("No province selected")
                    return [];
                }

                let provincePools = []

                // determine users of filtered province
                this.$store.state.user.userList.forEach(u => {
                    if (u.province === this.filteredProvince) {
                        provincePools.push(u)
                    }
                })

                return provincePools
            }
        },
        data: () => ({
            navigationIdx: 0, // Default: All
            filteredProvince: null,
            filteredPool: null,
            showAssignDialog: false,
            assignuuid: null,
            selectedUser: null,
            assignedUser : null
        }),
        methods: {
            onNavigationChange() {
                // filter surveys dependent on navigation
                this.filterSurveysByProvince((this.navigationIdx <= 0 ? 'all' : 'open'))
            },
            onProvinceSelectionChange(selectedProvince) {
                // clear previous selections
                this.filteredPool = null

                // filter users with same province
                let filteredUsers = this.$store.getters.userList.filter(u => u.province === selectedProvince)

                let filterArgs = {usersRef: filteredUsers}

                // query data with given arguments
                this.$store.dispatch('filterSurveys', filterArgs)
            },
            onPoolSelectionChange(selectedPool) {
                // filter users with same pool
                let filteredPool = this.$store.getters.userList.filter(u => u.pool === selectedPool)

                let filterArgs = {usersRef: filteredPool}

                // query data with given arguments
                this.$store.dispatch('filterSurveys', filterArgs)
            },
            filterSurveysByProvince(show = 'all') {
                // define empty args
                let filterArgs = null

                // get user profile and its role
                let userProfile = this.$store.getters.userProfile

                // ADMIN: filter for user of the same province
                if (userProfile && userProfile.role === Roles.ROLE_2.value) {
                    let users = this.$store.getters.userList

                    // filter users which belongs to the same province
                    let filteredUsers = users.filter(user => user.province === userProfile.province)

                    // set filter arguments
                    if(show=='all')
                        filterArgs = {usersRef: filteredUsers}
                    // set filter if we will only see open surveys
                    if(show=='open') {
                        filterArgs = {assignedWorker: true}
                    }
                }
                // CONTRACTOR: filter his own
                else if (userProfile.role === Roles.ROLE_3.value) {
                    if(show=='all')
                        filterArgs = {contractorRef: userProfile.email}
                    // overwrite filter for CONTRACTOR
                    if(show=='open')
                        filterArgs = {assignedWorker: userProfile.email}
                }
                // for SUPERADMIN
                else {
                    // set filter if we will only see open surveys
                    if(show=='open') {
                        filterArgs = {assignedWorker: true}
                    }
                }



                // query data with given arguments
                console.log("filterArgs:", filterArgs)
                this.$store.dispatch('filterSurveys', filterArgs)
            },
            showDialog(event){

                this.showAssignDialog=true
                this.assignuuid = event
                this.selectedUser = this.$store.getters.surveyByuuid(this.assignuuid).assignedWorker
                this.assignedUser = this.$store.getters.surveyByuuid(this.assignuuid).assignedWorker
                console.log(event)
            },
            assignUser(){
                let survey = this.$store.getters.surveyByuuid(this.assignuuid)

                if(typeof survey != 'undefined') {
                    survey["assignedWorker"] = this.selectedUser
                    this.$store.dispatch('applySurvey', survey)
                }
                else
                    console.error("Survey for assignment is undefined")
                this.showAssignDialog = false
            },
            deleteUser(){
                let survey = this.$store.getters.surveyByuuid(this.assignuuid)

                if(typeof survey != 'undefined') {
                    survey["assignedWorker"] = null
                    this.$store.dispatch('applySurvey', survey)
                }
                else
                    console.error("Survey for assignment is undefined")
                this.showAssignDialog = false
            }
        },
        mounted() {
            this.$store.dispatch('clearImageList')
            this.$store.dispatch('getPlants')

            //changed to promise, else a reload is required in case of a new survey
            this.$store.dispatch('getUsers')
                .then(() => this.$store.dispatch('getAllSurveys'))
                .then(() => {
                    let userProfile = this.$store.getters.userProfile

                    // pre-initialize component
                    this.filteredProvince = userProfile.province
                    //this.filteredPool = userProfile.pool

                    this.filterSurveysByProvince()
                })
        }
    };
</script>
